import { getObjectTypeName } from 'automation-ui-references/object-types/objectTypeUtils';

// @ts-expect-error untyped module customer-data-reference-ui-components
import UnknownName from 'customer-data-reference-ui-components/name/UnknownName';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import { useQuery } from 'data-fetching-client';
import { GET_OBJECT_TYPE_BY_ID } from 'automation-ui-references/object-type-properties/ObjectTypesQueries';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Example:
 *   <ObjectTypeName objectTypeId={'0-1'} isPlural={false} />
 * Renders as:
 *   contact
 *
 *
 */
const ObjectTypeName = ({
  objectTypeId,
  isPlural = false,
  isCapitalized = false
}) => {
  const {
    data: objectTypeDefinition,
    loading,
    error
  } = useQuery(GET_OBJECT_TYPE_BY_ID, {
    variables: {
      objectTypeId
    },
    skip: !objectTypeId
  });
  if (loading) {
    return /*#__PURE__*/_jsx(SkeletonText, {});
  } else if (error) {
    return /*#__PURE__*/_jsx(UnknownName, {});
  } else if (!objectTypeDefinition) {
    return null;
  }
  return /*#__PURE__*/_jsx("span", {
    children: getObjectTypeName({
      isCapitalized,
      isPlural,
      objectTypeDefinition: objectTypeDefinition.objectTypeById
    })
  });
};
export default ObjectTypeName;